export const CONFERENCE_SINGLE_PAGE = '/conference/single'
export const CONFERENCE_ARTICLE_SUBMISSION = '/conference/article-submission'
